import { render, staticRenderFns } from "./SectionBuilderPreview.vue?vue&type=template&id=19b5e7e3&"
import script from "./SectionBuilderPreview.vue?vue&type=script&lang=js&"
export * from "./SectionBuilderPreview.vue?vue&type=script&lang=js&"
import style0 from "./SectionBuilderPreview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCard,VCardText,VContainer,VFadeTransition})
